import { defineStore } from 'pinia'
import { useRequestFactory } from './factories/requestFactory'
import { AssetsV2Service } from '@/services/assets-v2-service'
import type { AssetExchangeContractMinResponse } from '@/services/assets-v2-service/types'
import { ref } from 'vue'

type ActionType = 'assets-contracts'
export const useAssetsStore = defineStore('assets', () => {
  const { loading, errors, requestHandler } = useRequestFactory<ActionType>()
  const myContracts = ref<AssetExchangeContractMinResponse[] | undefined>([])
  const fetchAssetsContracts = async () => {
    return await requestHandler('assets-contracts', async () => {
      const r = await AssetsV2Service.fetchAssetsContracts()
      return r.data
    })
  }
  const fetchAssetsContractsByAsset = async (asset: string, marketType: string = 'swap') => {
    return await requestHandler('assets-contracts-by-asset', async () => {
      const r = await AssetsV2Service.fetchAssetsContractsByAsset(asset, marketType)
      return r.data
    })
  }
  const fetchMyContracts = async () => {
    return await requestHandler('my-contracts', async () => {
      const r = await AssetsV2Service.fetchMyContracts()
      myContracts.value = r.data
      return r.data
    })
  }
  const deleteContract = async (contractId: number) => {
    return await requestHandler('delete-my-contract', async () => {
      const r = await AssetsV2Service.deleteMyContract(contractId)
      return r.data
    })
  }

  return {
    loading,
    errors,
    myContracts,
    fetchAssetsContracts,
    fetchAssetsContractsByAsset,
    fetchMyContracts,
    deleteContract,
  }
})
